/** @deprecated please use fazzBizzThemeFds3 colors theme instead */
export enum PRIMITIVES {
  VIVID_CERULEAN = '#00A0FF',
  TURQUOISE_SURF = '#00C1D5',
  MAJESTIC_BLUE = '#0925D9',
  ROYAL_BLUE = '#3C64E1',
}
